/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface BsDeviceInfo {
    family: string;
    deviceUniqueId: string;
    bootVersion: string;
    deviceBootCount: number;
    deviceLifetime: number;
    deviceUptime: number;
    version: string;
    model: string;
}

/**
 * Code unique to BrightSign
 */
export interface BrightSignInformationInterface {
    /**
     * Identify device hardware, firmware, etc.
     */
    getBsDeviceInfo(): Promise<BsDeviceInfo>;
}

export function supportsBrightSignInformation(
    platform: unknown
): platform is BrightSignInformationInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PlatformMessage.BsDeviceInfoGet);
    }
    return platform instanceof Object && 'getBsDeviceInfo' in platform;
}
